import * as React from 'react';
import { SVGProps } from 'react';
const ArrowLeftIconComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.0002 11.25H5.31018L10.5302 6.03L9.47018 4.97L3.32518 11.115C2.84018 11.6 2.84018 12.395 3.32518 12.885L9.47018 19.03L10.5302 17.97L5.31018 12.75H21.0002V11.25Z"
      fill="currentColor"
    />
  </svg>
);
export default ArrowLeftIconComponent;
